import React from "react";
import {API_URL} from "../env";
import axios from "axios";
import Loader from '../loader';
import {Link} from 'react-router-dom'
import PopUp from "../popup/pop-up";

const {useState, useEffect} = React

const AnalyzeResumesTable = () => {
    const [fetchedData, setFetchedData] = useState([])
    const [loading, setLoading] = useState(false);
    const [popup, setPopup] = useState(false);
    const [viewData, setViewdata] = useState([]);
    const fetchData = () => {
        setPopup(false);
        const url = window.location.href.indexOf("analyzed-resumes") > -1 ? `${API_URL.url}/fetchResumes` : `${API_URL.url}/fetchJds`;
        axios.get(url)
            .then(res => {
                setFetchedData(res.data)
            }).catch((error) => {
            throw error;
        })
    }
    const startParsingResumes = () => {
        setLoading(true)
        const url = window.location.href.indexOf("analyzed-resumes") > -1 ? `${API_URL.url}/extractTags` : `${API_URL.url}/extractJd` 
        axios.get(url)
            .then((resp) => {
                {setLoading(false)}
                alert("Processed Successfully")
            })
            .catch((error) => {
                {setLoading(false)}
                alert('Processing Failed. Please Try Again');
            })
    }

    const handleClick = item => {
        setPopup(true);
        setViewdata(item)
    }

    const handleClose = () => {
        setPopup(false)
    }

    const renderButton= () => {
        return (
            <div className="btn-container">
                <div className="btn" onClick={() => startParsingResumes()}>
                    {window.location.href.indexOf("analyzed-resumes") > -1 ? 'Process Resumes' : 'Process JDs'}
                </div>
            </div>
        )
    }
    const renderTagData = (item) => {
        return (
            <div className="list-alternate">
                {item.practiceArea && item.practiceArea.length > 0 ?
                    <div className="list">
                        <b>Practice Area</b>: {item.practiceArea.map((item, index) => <span className="list-last-item"
                                                                                            key={index}>{item}<p>, </p></span>)}
                    </div>
                    : null}
                {item.skills && item.skills.length > 0 ?
                    <div className="list">
                        <b>Skills</b>: {item.skills.map((item, index) => <span className="list-last-item"
                                                                               key={index}>{item}<p>, </p></span>)}
                    </div>
                    : null}
                {item.qualification && item.qualification.length > 0 ?
                    <div className="list">
                        <b>Qualification</b>: {item.qualification.map((item, index) => <span className="list-last-item"
                                                                                             key={index}>{item}<p>, </p></span>)}
                    </div>
                    : null}
                {item.qualificationSpecialization && item.qualificationSpecialization.length > 0 ?
                    <div className="list">
                        <b>Qualification Specialization</b>: {item.qualificationSpecialization.map((item, index) =>
                        <span className="list-last-item" key={index}>{item}<p>, </p></span>)}
                    </div>
                    : null}
                {item.experience && item.experience.length > 0 ?
                    <div className="list">
                        <b>Experience</b>: {item.experience.map((item, index) => <span className="list-last-item"
                                                                                       key={index}>{item}
                        <p>, </p></span>)}
                    </div>
                    : null}
                {item.businessSegment && item.businessSegment.length > 0 ?
                    <div className="list">
                        <b>Business Segment</b>: {item.businessSegment.map((item, index) => <span className="list-last-item"
                                                                                       key={index}>{item}
                        <p>, </p></span>)}
                    </div>
                    : null}
                {item.certification && item.certification.length > 0 ?
                    <div className="list">
                        <b>Certification</b>: {item.certification.map((item, index) => <span className="list-last-item"
                                                                                       key={index}>{item}
                        <p>, </p></span>)}
                    </div>
                    : null}
                {item.location && item.location.length > 0 ?
                    <div className="list">
                        <b>Location</b>: {item.location.map((item, index) => <span className="list-last-item"
                                                                                   key={index}>{item}<p>, </p></span>)}
                    </div>
                    : null}
            </div>
        )
    }

    useEffect(() => {
        fetchData();
    }, [window.location.href, loading])

    const messageOne = 'Please Wait'
    const messageTwo = window.location.href.indexOf('analyzed-resumes') > -1 ? 'Parsing Resumes' : 'Parsing JD'
    return (
        <div>
            {
                popup ?
                <PopUp viewData={viewData} handleClose={handleClose} renderTagData={renderTagData}/> : null
            }
            <div className="analyze-resume-container">
                {
                    loading ? <Loader messageOne={messageOne} messageTwo={messageTwo}/> : null
                }
                <div className="inner-container">
                    {renderButton()}
                    <div className="analyze-container-title"><b>
                        {window.location.href.indexOf("analyzed-resumes") > -1 ? 'Resumes' : 'JDs'}
                    </b></div>
                    <table className="data-table">
                        <tr className="header">
                            <th>Tags</th>
                            <th>{window.location.href.indexOf("analyzed-resumes") > -1 ? 'Resumes' : 'JDs'}</th>
                            {
                                window.location.href.indexOf("analyzed-resumes") > -1 ?
                                null : <th>Matches</th>
                            }
                        </tr>
                        {fetchedData.map((item, index) =>
                            <tr key={index}>
                                <td>
                                    <div className="list">
                                        {renderTagData(item)}
                                    </div>
                                </td>
                                <td>
                                    <div className="btn" onClick={() => handleClick(item)}>
                                    {
                                        window.location.href.indexOf("analyzed-resumes") > -1 ?
                                        'View Resume' : 'View JD'
                                    }
                                    </div>
                                </td>
                                {
                                    window.location.href.indexOf("analyzed-resumes") > -1 ?
                                    null : 
                                    <td>
                                        <Link to={{pathname: "/matchmaking", state: item}} className="btn">View Matches</Link>
                                    </td>
                                }
                            </tr>
                        )}
                    </table>
                </div>
            </div>
        </div>
    )
}

export default AnalyzeResumesTable;